<template>
  <!-- MARE: za mobilni da napravimo novu komponentu sa jednom slikom + logika da zauzima 2 mesta -->
  <!-- ko ubacije banner pise i alt za sliku -->
  <a :href="link" class="hidden m_580:inline-block">
    <div class="w-full h-full group grid m_1000:p-s20">
      <div class="relative overflow-hidden w-full h-full grid-area">
        <img v-if="image" :src="image" alt=""
          class="w-auto h-full max-w-none absolute top-0 inset-2/4 -translate-x-2/4" width="344" height="665" loading="lazy">
        <img v-else src="https://placehold.co/344x665/6d318b/FFFFFF/png" alt="" width="344" height="665" loading="lazy">
      </div>
      <div v-if="image_hover"
        class="relative overflow-hidden w-full h-full grid-area opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <img :src="image_hover" alt=""
          class="w-auto h-full max-w-none absolute top-0 inset-2/4 -translate-x-2/4" width="344" height="665" loading="lazy">
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "CategoryBanner",

	data() {
		return {
			image: this.$parent._data.bannerImages['image'],
			image_hover: this.$parent._data.bannerImages['image_hover'],
			link: this.$parent._data.bannerImages['link']
		}
	},
}
</script> 